<template>
  <div class="timepoint-group-container"> 
      
      <!--div class="rules-group-header">
          <div class="btn-group pull-right group-actions"-->

          <v-container fill-height fluid grid-list-xl>
            <v-layout justify-center wrap>
          
                <v-flex xs12 sm2 md2>
                 <v-text-field
                    label="Timepoint Name"
                    v-model="three.name"
                  ></v-text-field>
                </v-flex>

                 <v-flex xs12 sm2 md2 >
                 <v-text-field
                    label="N. Cycles"
                    v-model="three.cycles"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm2 md2 >
                 <v-text-field
                    label="Percentage %"
                    v-model="three.percentage"
                  ></v-text-field>
                </v-flex>


                <v-flex text-right xs12 sm6 md6>
                 <!--v-btn small color="primary" @click="addArm">Add Arm</v-btn-->
                  <v-btn v-if="!three.children.length" @click="remove" small color="danger">Delete</v-btn>
                </v-flex>
                
          
             <v-flex xs12 sm12 md12 v-if="!three.collapse">

      <div class="rules-group-body"> 
        <div class="rules-list">
          <component
            v-for="(child, index) in three.children"
            :key="index"
            :is="child.type"
            :type="child.type"
            :three.sync="child.three"
            :index="index"
            :maxDepth="maxDepth"
            :drugs="drugs"
            :depth="depth + 1"
            v-on:child-deletion-requested="removeChild">
          </component>
        </div>
      </div>

             </v-flex>


              <v-flex text-right xs12 sm12 md12>
                 <v-btn small color="primary" @click="addArm">Add Arm</v-btn>
                </v-flex>

         </v-layout>
    </v-container>
  </div>
</template>

<script>
import ArmGroup from "./ArmGroup.vue";

export default {
  name: "timepoint-group",

  components: {
    ArmGroup
  },

  props: ["type", "three", "index", "maxDepth", "depth", "drugs"],

  methods: {

     addArm() {
      this.three.children.push({
        type: "arm-group",
        three: {
          children: []
        }
      });
      this.$emit("update:three", this.three);
    },

    remove() {
      this.$emit("child-deletion-requested", this.index);
    },


    removeChild(index) {
      this.three.children.splice(index, 1);
      this.$emit("update:three", this.three);
    },

  },

  data() {
    return {};
  },
  computed: {
    hasMultipleRule() {
      return this.three.children.length > 1;
    }
  }
};
</script>
